module.exports = __webpack_public_path__ + "static/iconGps-7320586649ad278d94f2d7da24a969dd.png";